import {useState} from "react";
import {useAuth} from "../../auth/AuthProvider";
import {Button, Container, Form, Row, Col, InputGroup} from "react-bootstrap";
import {InnerUsersList} from "./InnerUsersList";
import {callSearchUsers} from "../../../lib/api/users/callSearchUsers";


export const SearchUsers = () => {
    const {token} = useAuth();
    const [searchQuery, setSearchQuery] = useState("");
    const [usersData, setUsersData] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSearch = (e) => {
        e.preventDefault();
        console.log("suca: ");
        console.log(searchQuery);
        setIsLoading(true);
        if (searchQuery) {
            callSearchUsers(token, searchQuery).then((res) => {
                setUsersData(res.users);
                setIsLoading(false);
            });
        }
    };

    return (
        <Container>
            <Form onSubmit={handleSearch}>
                <Row className="mb-3">
                    <Col md={6}>
                        <InputGroup>
                            <Form.Control
                                type="text"
                                placeholder="Search by email or username"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <Button variant="primary" type="submit">
                                Search
                            </Button>
                        </InputGroup>
                    </Col>
                </Row>
            </Form>

            <InnerUsersList usersData={usersData} isLoading={isLoading}/>


            


        </Container>
    );
};